import type { PropsWithChildren } from 'react';
import { cn } from '~/lib/utils';

type ContainerProps = PropsWithChildren & React.HTMLAttributes<HTMLDivElement>;

export function PageContainer({ children, className, ...props }: ContainerProps) {
  return (
    <main
      className={cn(
        // Note: `---spacing(17)` is Tailwind v4's canonical form for `- --spacing(17)`.
        // Tailwind inserts the required calc() whitespace at build time; _-_ encoding is equivalent.
        `
          flex min-h-[calc(100dvh---spacing(17))] flex-col gap-lg
          bg-background-100 p-lg
        `,
        className
      )}
      {...props}
    >
      {children}
    </main>
  );
}

export function SectionContainer({ children, className, ...props }: ContainerProps) {
  return (
    <div className={cn('mx-auto w-full max-w-[1280px]', className)} {...props}>
      {children}
    </div>
  );
}
